import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {teamContribution} from './defaultResponseModel/teamContribution';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_TEAM_CONTRIBUTION';

export async function getTeamContribution(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/team-contribution/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return teamContribution.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
